export default __webpack_public_path__ + "static/media/30t.8613c4cc.jpg";